/*
 * Module defining the menu bar
 */

define([
  "marionette",
  "messaging/messenger",
  "configuration/properties",
  "modules/header/menuBar/menuBarView",
  "modules/header/menuBar/menuBarModel",
], function (Marionette, Messenger, Properties, MenuBarView, MenuBarModel) {
  var MenuBarController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "menuBar";
      this.region = options.region;
      this.activeItem = null;
      //get items for menu bar.  use the default kb initially, until Backbone.history
      //starts and can tell use which one specifically to use
      this.menuItems = Messenger.reqres.request("menu:bar:items");
      this._setUpCommands();
      this._setUpVents();
    },
    show: function () {
      this.view = new MenuBarView.menuBarView({ collection: this.menuItems });
      this.view.on(
        "itemview:click:menu",
        function (clickedView) {
          Messenger.save(function (success) {
            if (success) {
              //hide the context menu
              Messenger.vent.trigger("hide:context:menu");
              this.setActiveItem(clickedView);
              var clickedName = clickedView.model.get("name");
              switch (clickedName) {
                case "topics":
                  Messenger.vent.trigger("show:topics");
                  break;
                case "contents":
                  Messenger.vent.trigger("show:contents");
                  break;
                case "substitutions":
                  Messenger.vent.trigger("show:substitutions");
                  break;
                case "learner":
                  Messenger.vent.trigger("show:learner");
                  break;
                case "reports":
                  Messenger.vent.trigger("show:reports");
                  break;
                case "tasks":
                  Messenger.vent.trigger("show:reviewer"); //show the reviewer UI
                  break;
                case "actions":
                  Messenger.vent.trigger("show:actions");
                  break;
              }
            }
          }, this);
        },
        this,
      );
      this.showRegion(this.view);
    },
    setActiveItem: function (clickedView) {
      if (clickedView === null || clickedView !== this.activeItem) {
        if (this.activeItem) {
          //switching away from a menu item
          this.activeItem.toggleActive();
        } else {
          //switching away from the home button
          Messenger.vent.trigger("toggle:home:button", false);
        }
        this.activeItem = clickedView;
        if (this.activeItem) {
          //switching to a menu item
          this.activeItem.toggleActive();
        } else {
          //switching to the home button
          Messenger.vent.trigger("toggle:home:button", true);
        }

        //Unselect the admin menu
        Messenger.vent.trigger("toggle:admin:button", false);
      }
    },
    _setUpCommands: function () {
      Messenger.command.setHandler(
        "change:menu",
        function (menuName) {
          //hide the context menu
          Messenger.vent.trigger("hide:context:menu");
          console.log("change menu");
          var model = null;
          if (menuName) {
            model = this.menuItems.findWhere({ name: menuName });
          }
          if (model) {
            var view = this.view.children.findByModel(model);
            this.setActiveItem(view);
          } else {
            this.setActiveItem(null);
          }
        },
        this,
      );

      Messenger.command.setHandler(
        "update:menu:bar",
        function () {
          this.menuItems = Messenger.reqres.request("menu:bar:items");
          //determine if we show the tasks and actions menu
          var activeKb = Messenger.reqres.request("active:kb:model");
          if (activeKb.get("taskManagement")) {
            var taskMenuItem = this.menuItems.findWhere({ name: "tasks" });
            //must check if the menu contains the tasks item before showing it
            if (taskMenuItem) taskMenuItem.set("hidden", false);
          }
          if (activeKb.get("actionGroups")) {
            var actionMenuItem = this.menuItems.findWhere({ name: "actions" });
            //must check if the menu contains the actions item before showing it
            if (actionMenuItem) actionMenuItem.set("hidden", false);
          }
          this.view.collection = this.menuItems;
          this.view.render();
          //If the user pasted in a URL, and the KBs arrived after the initial
          //routing of the URL (which would have highlighted the open section),
          //then this update would wipe out the highlighting.  So re-set the highlighting.
          if (this.activeItem) {
            var modelName = this.activeItem.model.get("name");
            var newModel = null;
            if (modelName) {
              newModel = this.menuItems.findWhere({ name: modelName });
            }
            if (newModel) {
              var view = this.view.children.findByModel(newModel);
              this.setActiveItem(view);
            }
          }
        },
        this,
      );
    },
    _setUpVents: function () {},
  });

  return MenuBarController;
});
